import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export interface CustomerRecallBotSetting {
  enabled: boolean;
  rejoinEnabled: boolean;
}

export async function getRecallBotSetting(customerId: number): Promise<CustomerRecallBotSetting> {
  try {
    const res = await axios.get<CustomerRecallBotSetting>(
      `${API_URL}/CustomerSettings/${customerId}/recall-bot`
    );
    return {
      enabled: !!res.data?.enabled,
      rejoinEnabled: !!res.data?.rejoinEnabled,
    };
  } catch {
    return { enabled: false, rejoinEnabled: false };
  }
}

export async function updateRecallBotSetting(
  customerId: number,
  setting: CustomerRecallBotSetting
): Promise<void> {
  await axios.put(`${API_URL}/CustomerSettings/${customerId}/recall-bot`, {
    enabled: setting.enabled,
    rejoinEnabled: setting.rejoinEnabled,
  });
}

export interface CustomerAiAssignmentSetting {
  autoAssignEnabled: boolean;
  minMarginOverride: number | null;
  defaultMinMarginPercent: number | null;
}

export async function getAiAssignmentSetting(
  customerId: number
): Promise<CustomerAiAssignmentSetting | null> {
  const res = await axios.get<{ result: CustomerAiAssignmentSetting }>(
    `${API_URL}/CustomerSettings/${customerId}/ai-assignment`
  );

  const data = res.data?.result;
  if (!data) return null;

  return {
    autoAssignEnabled: !!data.autoAssignEnabled,
    minMarginOverride: data.minMarginOverride ?? null,
    defaultMinMarginPercent: data.defaultMinMarginPercent ?? null,
  };
}

export async function updateAiAssignmentSetting(
  customerId: number,
  setting: { autoAssignEnabled: boolean; minMarginOverride: number | null }
): Promise<void> {
  await axios.put(`${API_URL}/CustomerSettings/${customerId}/ai-assignment`, {
    autoAssignEnabled: setting.autoAssignEnabled,
    minMarginOverride: setting.minMarginOverride,
  });
}
